export type HomeWorkRow = {
  status: string;
  priority?: string;
  consoleKind: string;
};

const LENS_PATTERN = /^(status:(not_started|in_progress|gap|reviewed|blocking|recommended)|program:(ofac|gov|web|cloud|education|ai|formation))$/;

export function parseHomeLens(raw: string | null | undefined): string {
  const lens = String(raw || '').trim().toLowerCase();
  return LENS_PATTERN.test(lens) ? lens : '';
}

export function rowMatchesHomeLens(row: HomeWorkRow, lens: string): boolean {
  if (!lens) return true;
  if (lens.startsWith('program:')) {
    const id = lens.slice('program:'.length);
    if (id === 'gov') return row.consoleKind === 'dod-contracts-compliance';
    if (id === 'web') return row.consoleKind === 'website-compliance';
    if (id === 'cloud') return row.consoleKind === 'cloud-compliance';
    if (id === 'education') return row.consoleKind === 'education-compliance';
    if (id === 'ai') return row.consoleKind === 'ai-compliance';
    if (id === 'formation') return row.consoleKind === 'business-creation-compliance';
    if (id === 'ofac') return row.consoleKind === 'ofac-compliance';
    return false;
  }
  const status = lens.slice('status:'.length);
  if (status === 'blocking') {
    return row.consoleKind === 'dod-contracts-compliance' && row.priority === 'blocking' && row.status !== 'reviewed';
  }
  if (status === 'recommended') {
    return row.priority === 'recommended' && row.status !== 'reviewed';
  }
  return row.status === status;
}
